<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Product Tags'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Product Tags'
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name', width: '150px' },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'productTags/index',
            deleteItem: 'productTags/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/product-tags/${id}/edit`);
        },
        onAddButtonClick() {
            this.$router.push('/product-tags/add');
        }
    }
};
</script>
